import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson2: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center p-[2.69rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV />
      <div className="self-stretch flex flex-row items-center justify-between">
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson1"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Back
            </b>
          </div>
        </a>
        <div className="flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">Crypto Markets</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson3"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Next
            </b>
          </div>
        </a>
      </div>
      <div className="flex flex-col items-center justify-center gap-[6.81rem] w-[92%] mr-[4%] max-w-[110rem]text-justify text-[1.88rem] text-white font-dm-sans">

        <div className="self-stretch flex flex-row items-center justify-center gap-[6.88rem] text-[1.56rem] text-gainsboro-100">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0 text-[1.88rem] text-white">
              <b>What is the Crypto Primary Market</b>
            </p>
            <p className="m-0">&nbsp;</p>
            <p className="m-0">&nbsp;</p>
            <p className="m-0">
              The primary market for cryptos can be defined as a place or
              occasion where issuers issue new crypto assets to investors for
              the first time, and investors directly buy the assets from the
              initial issuance.
            </p>
            <p className="m-0">
              With the development of the crypto industry over the years, the
              issuance mechanism (method in which securities are issued) of the
              primary market has continuously changed, becoming more equitable
              for both the issuer and the investor.
            </p>
          </div>
          <img
            className="relative w-[36.25rem] h-[24.13rem] object-cover"
            alt=""
            src="/i7@2x.png"
          />
        </div>
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          As the crypto industry evolved so did the issuance mechanisms, here
          are a few of the notable ones over the years:
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Proof of Work (PoW) Mining</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                The first distribution mechanism was the PoW mining mechanism.
                It began with Bitcoin when Satoshi Nakamoto calculated the
                genesis block in the Proof-of-Work mechanism (PoW). PoW
                signifies the beginning of the Bitcoin network and cryptos.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>How Does POW Mining Work?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  The PoW crypto distribution mechanism involves miners
                  allocating their resources (time, equipment, and energy) to
                  solve computational problems. Since they have put lots of
                  their own material resources (computational power and energy)
                  into mining they are rewarded in exchange for bitcoin. In
                  doing so they are buying encrypted assets on the primary
                  market.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Developers can also have "pre-mining" operations on these
                  assets before they go into circulation with the public. (This
                  is very similar to NFT whitelisting - which allows for NFTs to
                  be purchased before public release)
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Recently, new methods have begun to exist, such as Proof of
                  Stake.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">{`Proof of Stake (PoS) `}</b>
                <span>
                  serves a similar function to proof of work’s mining.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  It is the process by which a network participant gets selected
                  to add the latest batch of transactions to the blockchain and
                  earn some crypto in exchange, but “validators” (Miners) who
                  contribute — or “stake” — their own crypto in exchange for a
                  chance of getting to validate new transactions, update the
                  blockchain, and earn a reward.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Initial Coin Offering (ICO)</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Similar to a stock's IPO, a crypto's ICO or Initial Coin
                Offering is used as a way to raise capital or funds when a
                company/project looking to raise money to create a new coin,
                app, or service launches an ICO.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Interested investors are able to buy into the offering and will
                receive a new cryptocurrency token issued by the company. That
                token will have some form of utility in using the product or
                service the company is offering, or it can also just represent a
                stake in the company or project.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                When a cryptocurrency startup wants to raise money through ICO,
                they usually creates a whitepaper. Think of the whitepaper as a
                manifesto that outlines what the project is about, how much
                money is needed, need the project will fulfill upon completion,
                how many of the virtual tokens the founders will keep, what type
                of currency will be accepted, and how long the ICO campaign will
                run for.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                During that ICO campaign, those interested in the project can
                buy some of the project’s tokens with fiat (US Dollar/Euro/etc)
                or digital currency. These coins are referred to as "tokens" by
                the buyers. A good comparison here to help better understand it
                is thinking of these tokens as similar to the shares received
                during a company's "IPO" on the stock market.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0 text-[1.75rem]">
            <b>
              <span>
                Good questions to ask yourself when making a decision to invest
                into an ICO are:
              </span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Who owns the company? An identifiable and well-known owner is
                  a good sign.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Are there other major investors who are investing in it? It’s
                  a positive sign if other well-known investors want a piece of
                  this cryptocurrency.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Will you own a stake in the company or just currency or
                  tokens? This distinction is important. Owning a stake means
                  you get to participate in its earnings (you’re an owner),
                  while buying tokens simply means you're entitled to use them,
                  like chips in a casino.
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  Look for if the currency already developed, or is the company
                  looking to raise money to develop it. Of course the further
                  along the currency, the less risky it is.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.88rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Secondary Markets - Exchanges</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Once a cryptocurrency is sold on the primary market (ICOs,
                  Mining, etc) it will then be available to buy, sell and trade
                  on the secondary market commonly referred to as exchanges.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[33.63rem] h-[18.3rem] object-cover"
            alt=""
            src="/i8@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>
                What is a Crypto Exchange and What are Some of it's Uses?
              </span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  It is a platform where you can buy and sell (trade) crypto
                  currency
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Allows for users to trade one crypto for another, i.e
                  converting Solana to Bitcoin
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Allows for users to buy crypto using fiat currencies
                  (USD/EURO)
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Accurately reflects current market prices of the
                  cryptocurrency offered
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Exchanges allow for the market to be extremely liquid
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  Allows for users to convert crypto back into fiat currencies
                  and to leave as cash within your account (Ease of access if
                  users wish to trade crypto further on) or withdraw to your
                  bank account
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            The role of the secondary market is to provide access for the
            average crypto investor to these cryptocurrencies, which they would
            more than likely not be able to obtain from the primary market.
          </p>
          <p className="m-0">
            {`There are many different exchanges that operate for cryptocurrency. Please check out our in-depth `}
            <a
              className="text-[inherit]"
              href="https://www.notion.so/3508323846cb4b04a2aa8373db6f8e5f?pvs=21"
              target="_blank"
            >
              <span className="[text-decoration:underline]">
                Exchanges Guide
              </span>
            </a>{" "}
            for more information on the various exchanges and their individual
            benefits.
          </p>
          <p className="m-0">
            All of these exchanges allow for the 24/7 crypto market to be
            extremely liquid.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Takeways</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>{`The primary market is largely based on token sale platforms. The limitation with this market stems not from the number of tokens but rather the buyer's risk tolerance and their qualifications. `}</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                So to simplify the concept the primary buyers in the crypto
                market are usually those who can afford to risk their money on a
                new project, or have managed to grab tokens.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Your risk tolerance should be extremely high if you plan on
                participating in the primary market. On the other hand, the
                secondary crypto/token market is the place where all the others
                (average crypto investors - you and I) can then buy tokens after
                the initial token sale is over.
              </span>
            </span>
          </p>
        </div>
        <a className="w-full mb-[6rem] rounded-32xl bg-gainsboro-200 box-border flex flex-row items-center justify-between py-[0.75rem] px-[0rem] max-w-[25rem] text-center text-[2.81rem] border-[1px] border-solid border-gray-300"
          href="/lesson3">
          <div className="w-full">
            <b className="inline-block flex-1 w-full relative text-center pb-[0.8rem]">Next Chapter</b>
          </div>
        </a>
      </div>
    </div>
  );
};

export default Lesson2;
